import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from '@/app/router'

import PrimeVue from 'primevue/config'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'
import 'primeicons/primeicons.css'

import Aura from '@primevue/themes/aura'
import '@fontsource/inter/index.css'
import './assets/styles/themes.css'
import './assets/styles/base.css'
import Tooltip from 'primevue/tooltip'


const root = document.documentElement

if (!root.dataset.theme) {
  root.dataset.theme = 'soft-stone'
}

const app = createApp(App)

const pinia = createPinia()

app.use(pinia)
app.use(router)

app.use(PrimeVue, {
  ripple: true,
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: false
    }
  }
})

app.directive('tooltip', Tooltip)
app.use(ToastService)
app.use(ConfirmationService)

app.mount('#app')
